// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.majority-alignment {
  font-family: Arial, sans-serif;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.majority-alignment h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  text-align: left;
}

.chart-description {
  background-color: #f8f8f8;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chart-description .text {
  font-size: 16px;
  line-height: 1.5;
  color: #333;
}

.filters {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.filters select {
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
  flex: 1 1;
  min-width: 150px;
  max-width: 200px;
  background-color: white;
}

.top-ten-chart,
.histogram {
  margin-top: 30px;
  border-radius: 4px;
  padding: 20px 0;
  width: 100%;
  overflow: visible;
  display: flex;
  justify-content: center;
}

.histogram svg {
  width: 100%;
  height: auto;
  overflow: visible;
  margin-bottom: 20px; /* Add some bottom margin */
}

.top-fifty-chart {
  margin-top: 10px;
  border: none;
  padding: 5px;
  width: 100%;
  overflow: hidden;
}

.show-more-button {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.show-more-button:hover {
  background-color: #0056b3;
}

.show-all-button {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.show-all-button:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .majority-alignment h2 {
    font-size: 20px;
  }

  .filters {
    flex-direction: column;
  }

  .filters select {
    width: 100%;
    margin-right: 0;
  }

  .majority-alignment {
    padding: 10px;
  }

  .top-ten-chart,
  .histogram {
    padding: 10px;
  }

  .histogram {
    padding: 10px 0;
  }

  .histogram svg {
    height: auto;
  }

  .majority-alignment {
    overflow-x: hidden;
  }
}

@media (max-width: 480px) {
  .majority-alignment {
    padding: 10px;
  }

  .top-ten-chart,
  .histogram {
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MajorityAlignment/style.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".majority-alignment {\n  font-family: Arial, sans-serif;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.majority-alignment h2 {\n  font-size: 24px;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.chart-description {\n  background-color: #f8f8f8;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.chart-description .text {\n  font-size: 16px;\n  line-height: 1.5;\n  color: #333;\n}\n\n.filters {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.filters select {\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  flex: 1;\n  min-width: 150px;\n  max-width: 200px;\n  background-color: white;\n}\n\n.top-ten-chart,\n.histogram {\n  margin-top: 30px;\n  border-radius: 4px;\n  padding: 20px 0;\n  width: 100%;\n  overflow: visible;\n  display: flex;\n  justify-content: center;\n}\n\n.histogram svg {\n  width: 100%;\n  height: auto;\n  overflow: visible;\n  margin-bottom: 20px; /* Add some bottom margin */\n}\n\n.top-fifty-chart {\n  margin-top: 10px;\n  border: none;\n  padding: 5px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.show-more-button {\n  display: block;\n  margin: 20px auto;\n  padding: 10px 20px;\n  font-size: 16px;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.show-more-button:hover {\n  background-color: #0056b3;\n}\n\n.show-all-button {\n  display: block;\n  margin: 20px auto;\n  padding: 10px 20px;\n  font-size: 16px;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.show-all-button:hover {\n  background-color: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .majority-alignment h2 {\n    font-size: 20px;\n  }\n\n  .filters {\n    flex-direction: column;\n  }\n\n  .filters select {\n    width: 100%;\n    margin-right: 0;\n  }\n\n  .majority-alignment {\n    padding: 10px;\n  }\n\n  .top-ten-chart,\n  .histogram {\n    padding: 10px;\n  }\n\n  .histogram {\n    padding: 10px 0;\n  }\n\n  .histogram svg {\n    height: auto;\n  }\n\n  .majority-alignment {\n    overflow-x: hidden;\n  }\n}\n\n@media (max-width: 480px) {\n  .majority-alignment {\n    padding: 10px;\n  }\n\n  .top-ten-chart,\n  .histogram {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
